import { render, staticRenderFns } from "./ItemWriteCurationLayout.vue?vue&type=template&id=7942b6a4&scoped=true"
import script from "./ItemWriteCurationLayout.vue?vue&type=script&lang=js"
export * from "./ItemWriteCurationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942b6a4",
  null
  
)

export default component.exports